import { useState } from 'react';

const useLocalStorage = (key, defaultValue) => {
  const [localStorageValue, setLocalStorageValue] = useState(() => {
    try {
      const value = localStorage.getItem(key);
      if (value) {
        return JSON.parse(value);
      }
      localStorage.setItem(key, JSON.stringify(defaultValue));
      return defaultValue;
    } catch (error) {
      console.error(error);
      return defaultValue;
    }
  });
  const setLocalStorageStateValue = (value) => {
    localStorage.setItem(key, JSON.stringify(value));
    setLocalStorageValue(value);
  };
  const removeLocalStorageValue = () => {
    localStorage.removeItem(key);
    setLocalStorageValue(null);
  };
  return [localStorageValue, setLocalStorageStateValue, removeLocalStorageValue];
};

export default useLocalStorage;
